import type { SegmentUsage } from './segment-usage';

export const SEGMENT_USAGE_TAGS = {
  trigger: 'Trigger',
  audience: 'Audience',
  exclusion: 'Excluded',
  checkAudience: 'Check Audience',
} as const satisfies Record<SegmentUsage['kind'], string>;

export const SEGMENT_USAGE_PHRASES = {
  trigger: 'as the trigger',
  audience: 'as the audience',
  exclusion: 'as the exclusion',
  checkAudience: 'in a Check Audience step',
} as const satisfies Record<SegmentUsage['kind'], string>;

export const AUDIENCE_AND_EXCLUSION_PROBLEM =
  'is both the audience and an exclusion. A segment can’t be both, so you won’t be able to save until you change one.';
export const EXCLUDED_ELSEWHERE_PREFIX = 'is excluded but also used';
export const EXCLUDED_ELSEWHERE_SUFFIX = ', so no one in it will be sent anything from this automation.';

export const UNNAMED_SEGMENT_LABEL = 'This segment';

export const EXCLUDE_TAB_LABEL = 'Exclude segments';
export const EXCLUDE_TAB_OPTIONAL_HINT = 'Optional';
export const EXCLUDE_TAB_SELECTED_SUFFIX = 'selected';

export const EXCLUDE_INTRO =
  'Excluding segments is optional, and you can pick more than one. Anyone in any of the selected segments is skipped at every send, even if they’ve already started this automation. Avoid excluding a segment that’s used as the trigger, the audience, or in a Check Audience step: no one in it would be sent anything.';

export const NO_EXCLUSION_PREFIX = 'No exclusion:';
